const DEFAULT_SETTINGS = Object.freeze({
  is_active: true,
  headline: 'FW Kantine für deine Wache',
  message: '',
  website_url: 'https://fw-kantine.de',
  email_token: null,
  has_email: false,
  whatsapp_number: null,
  whatsapp_message: '',
});

export const getForcedPrelaunchSettings = () => {
  const config = typeof window === 'undefined' ? {} : (window.APP_CONFIG || {});
  if (config.force_prelaunch !== true) return null;

  const supplied = config.prelaunch_settings;
  const safeSettings = supplied && typeof supplied === 'object' && !Array.isArray(supplied)
    ? supplied
    : {};

  return {
    ...DEFAULT_SETTINGS,
    ...safeSettings,
    is_active: true,
  };
};
